import { render, staticRenderFns } from "./manage-reservation.vue?vue&type=template&id=68ae8905&"
import script from "./manage-reservation.vue?vue&type=script&lang=js&"
export * from "./manage-reservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports